import classnames from 'classnames';
import Button from 'components/Button/Button';
import CountdownRenderer from 'components/CountdownRenderer/CountdownRenderer';
import LoadingImage from 'components/LoadingImage/LoadingImage';
import withCountry, { IWithCountryProps } from 'enhancers/withCountry';
import withLanguageState, {
  WithLanguageProps
} from 'enhancers/withLanguageState';
import * as React from 'react';
import Countdown, { ICountdownRendererProps } from 'react-countdown-now';
import styled from 'styled-components';

interface IProps {
  src: string;
  loading?: boolean;
  showGlobalRegistration: boolean;
  text: {
    DaysText: string;
    HoursText: string;
    MinutesText: string;
    SecondsText: string;
    ButtonText: string;
    CountdownText: string;
    SplashText: string;
    ButtonLink: string | null;
  };
  date: Date;
}

type Props = IProps & IWithCountryProps & WithLanguageProps;

export const SplashImage: React.SFC<Props> = props => {
  const CountdownWithText: React.SFC<ICountdownRendererProps> = dateProps => (
    <CountdownRenderer
      text={{
        DaysText: props.text.DaysText,
        HoursText: props.text.HoursText,
        MinutesText: props.text.MinutesText,
        SecondsText: props.text.SecondsText
      }}
      {...dateProps}
    />
  );

  if (props.loading) {
    return <Container />;
  }

  return (
    <Container>
      <StyledImage src={props.src} loading={props.loading} />
      <Content>
        <SplashText className={classnames('wow slideInUp')}>
          {props.text.SplashText}
        </SplashText>
        <div data-wow-delay=".5s" className={classnames('wow slideInUp')}>
          <Countdown renderer={CountdownWithText} date={props.date} />
        </div>
        <CountdownText
          data-wow-delay="1s"
          className={classnames('wow slideInUp')}
        >
          {props.text.CountdownText}
        </CountdownText>
        {((props.country === 'global' && props.showGlobalRegistration) ||
          (props.country !== 'global' && props.showGlobalRegistration)) && (
          <Button link={'/register'}>
            {props.getText(props.text.ButtonText)}
          </Button>
        )}
      </Content>
    </Container>
  );
};

const SplashText = styled.div`
  font-size: 40px;
  margin-bottom: 10px;
  text-transform: uppercase;
  text-align: center;
`;

const Container = styled.div`
  height: calc(100vh - 104px);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
  @media (max-width: 1000px) {
    height: calc(100vh - 110px);
  }
  color: white;
`;

const Content = styled.div`
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 700;
`;

const CountdownText = styled.div`
  display: flex;
  font-size: 23px;
  font-weight: 700;
  justify-content: center;
  text-transform: uppercase;
  margin-top: 5px;
  margin-bottom: 20px;
  @media (max-width: 900px) {
    font-size: 20px;
  }
`;

const StyledImage = styled(LoadingImage)`
  flex-shrink: 0;
  min-height: 100%;
  min-width: 100%;
  position: absolute;
  z-index: 0;
`;

export default withLanguageState(withCountry(SplashImage));



// WEBPACK FOOTER //
// ./src/components/SplashImage/SplashImage.tsx